(() => {
  const initializeFinalCta = (root) => {
    if (!root || root.dataset.agArtworkFinalCtaBound === 'true') return;

    const form = document.getElementById(root.dataset.formId);
    const button = root.querySelector('[data-ag-artwork-final-cta-button]');

    if (!form || !button) return;

    const productForm = form.closest('product-form');
    const cartDrawer = document.querySelector('cart-drawer');
    const sourceButton = productForm?.querySelector('.product-form__submit');

    root.dataset.agArtworkFinalCtaBound = 'true';

    if (productForm && cartDrawer) productForm.cart = cartDrawer;

    const syncButtonState = () => {
      if (!sourceButton) return;

      const isLoading = sourceButton.classList.contains('loading');
      const isUnavailable = sourceButton.hasAttribute('disabled');
      const isAriaDisabled = sourceButton.getAttribute('aria-disabled') === 'true';

      button.disabled = isUnavailable || isAriaDisabled || isLoading;
      button.classList.toggle('loading', isLoading);

      if (isUnavailable || isAriaDisabled || isLoading) {
        button.setAttribute('aria-disabled', 'true');
      } else {
        button.removeAttribute('aria-disabled');
      }

      button.querySelector('.loading__spinner')?.classList.toggle('hidden', !isLoading);
    };

    form.addEventListener('submit', () => {
      if (button.disabled) return;

      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('loading');
      button.querySelector('.loading__spinner')?.classList.remove('hidden');
    });

    if (sourceButton) {
      new MutationObserver(syncButtonState).observe(sourceButton, {
        attributes: true,
        attributeFilter: ['aria-disabled', 'class', 'disabled'],
      });
    }

    syncButtonState();
  };

  const initializeAll = () => {
    document.querySelectorAll('[data-ag-artwork-final-cta]').forEach(initializeFinalCta);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', initializeAll);
})();
